import { render, staticRenderFns } from "./DummyPreview.vue?vue&type=template&id=444ea87f&scoped=true&"
import script from "./DummyPreview.vue?vue&type=script&lang=js&"
export * from "./DummyPreview.vue?vue&type=script&lang=js&"
import style0 from "./DummyPreview.vue?vue&type=style&index=0&id=444ea87f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ea87f",
  null
  
)

export default component.exports